
<div class="relative" :class="textfieldClasses">
  <input
    :id="id"
    v-model="content"
    class="text-field-input pr-56"
    :type="type"
    :aria-label="ariaLabel"
    :aria-invalid="hasError"
    :aria-describedby="ariaDescribedByName"
    :value="content"
    :name="name"
    autocomplete="off"
    @keydown.down="onArrowDown"
    @keydown.up="onArrowUp"
    @keydown.enter="onEnter"
    @blur="handleBlur"
  />
  <label :class="'pointer-events-none ' + textfieldLabelFilled" :for="id">{{ labelName }}</label>
  <ul v-show="isOpen && !hasError && results.length" class="autocomplete-results">
    <li
      v-for="(result, i) in results"
      :key="i"
      class="autocomplete-result"
      :class="{ 'is-active': i === arrowCounter }"
      @mousedown="setResult(result)"
    >
      <span v-html="formatText(result.display)" />
    </li>
  </ul>
  <div class="text-field-icon">
    <icon-magnifying-glass />
  </div>
  <HelperText v-if="displayHelperText" :id="id" :status="status" :text="displayHelperText" />
</div>
